import styled from "@emotion/styled";
import { FontSizeInPx, FontWeight, LineHeightInPx, Spacing } from "@snapchat/snap-design-system";

export const QuestionIcon = styled.img`
    width: 72px;
    height: 72px;
`;

export const UnknownErrorsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    height: 450px;
`;

export const UnknownErrorsMessageContent = styled.span`
    margin-top: ${Spacing["1XS"]}px;
    font-size: 11px;
    font-weight: ${FontWeight.NORMAL};
    line-height: 14px;
`;

export const UnknownErrorsMessageTitle = styled.span`
    margin-top: ${Spacing.SM}px;
    font-size: ${FontSizeInPx.COMPACT}px;
    font-weight: ${FontWeight.MEDIUM};
    line-height: ${LineHeightInPx.REGULAR}px;
`;
